<template>
  <DxPopup
    :visible="true"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-title="true"
    :width="900"
    height="auto"
    :show-close-button="true"
    :title="title"
    @hiding="close()"
  >
    <f7-block class="padding margin-half">
      <f7-row>
        <f7-col>
          <div class="dx-field">
            <div class="margin-bottom-half">
              {{
                $t("treatment.treatmentPlan.treatmentCreatePlan.annotations")
              }}
            </div>
            <div>
              <DxTextBox
                :value="annotation"
                @value-changed="onChangeDescription"
              />
            </div>
          </div>
        </f7-col>
      </f7-row>
    </f7-block>

    <f7-block class="margin-half">
      <f7-row>
        <f7-col>
          <f7-button
            class="
              dx-btn-cancel
              margin-left-block
              btn-width-150
              outlined-gray
              margin-top-block margin-bottom-block
            "
            raised
            type="default"
            styling-mode="contained"
            @click="close()"
          >
            Abandonar
          </f7-button>
        </f7-col>
        <f7-col class="justify-content-end">
          <f7-button
            class="
              dx-btn-cancel
              margin-right-block
              btn-width-150
              margin-top-block margin-bottom-block
              standard-blue-btn
            "
            raised
            type="success"
            styling-mode="contained"
            @click="save()"
          >
            {{ $t("save") }}
          </f7-button>
        </f7-col>
      </f7-row>
    </f7-block>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import { DxTextBox } from 'devextreme-vue/text-box';

export default {
  name: 'PopupProductAnnotation',
  components: {
    DxPopup,
    DxDataGrid,
    DxColumn,
    DxTextBox,
  },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      annotation: '',
    };
  },
  computed: {
    title() {
      return this.product?.name ?? '';
    },
  },
  mounted() {
    this.annotation = this.product?.observation ?? '';
  },
  methods: {
    close() {
      this.$emit('close');
    },
    save() {
      this.$emit('save', { ...this.product, observation: this.annotation });
      this.$emit('close');
    },
    onChangeDescription(e) {
      this.annotation = e.value;
    },
  },
};
</script>

<style src="./PopupProductAnnotation.styles.scss" scoped lang="scss"></style>
